import {AxiosServer, ArrRemoveSubItem,AxiosEsb} from '../../utils';
import {message} from 'antd';
import {server} from '../../config/serverConfig';
let namespace = 'orderDerClientQuotaAc_';

//直接dispatch 为同步方法，比如  dispatch({type:'login/set',payload:{loading:false}});
//store 使用了thunk中间件，以下方法均为异步加载。

const orderDerClientQuotaAc ={
	SET:(value) =>(dispatch,getState)=>{
		dispatch({type: namespace+'forcedUpdate', payload: value})},

	GET:(value)=>(dispatch,getState)=>{
		let store =getState().orderDerClientQuotaRd;
		let {dataFetchProps,pagination} =store;
		let {current:currentPage,pageSize} =pagination;
		dataFetchProps ={...dataFetchProps,...value,currentPage,pageSize}

		let Axios = AxiosServer();
		return Axios.post('/dayDerClientQuota/findAll',dataFetchProps).then((res)=>{

			if (res.data.status == true){
				pagination ={...pagination,total:res.data.count}
				dispatch({type: namespace+'forcedUpdate', payload: {data:res.data.data, pagination:pagination,dataLoading: false}});  // 翻页的时候，先更新 dataLoading: true
				return '刷新成功'
			}else{
				dispatch({type: namespace+'forcedUpdate', payload: {dataLoading: false}});
				return '刷新失败'
			}

		}).catch((err)=>{
			message.error('userlist ' + err,10);
			dispatch({type: namespace+'forcedUpdate', payload: {dataLoading: false}});
			return '错误'
		})},


	//导出excel文件
	GETXLS:()=>(dispatch,getState)=>{
		let store =getState().orderDerClientQuotaRd;
		let {dataFetchProps,searchProps} =store;
		let props ={...dataFetchProps,...searchProps,pageSize: 5000};
		let Axios = AxiosServer();
		return Axios.post('/api/excel/export/derClientQuotaReport',props).then((res)=>{
			if (res.data.filename){
				return (server.path+ res.data.filename);
			}else{
				return '下载失败';
			}

		}).catch((err)=>{
			message.error('错误:' + err.message,10);
			return '错误'
		})
	},
}



export {orderDerClientQuotaAc};